import ServicesConfig from '@/config/ServicesConfig';
import Axios from 'axios';
import querystring from "querystring"
import AppConfig from '../config/AppConfig';

export default {

	login(username, password) {
		let params = {
			grant_type: "password",
			client_id: "5c33d309cc761c4d05397c6d",
			client_secret: "65051e36023fa92764bcf351b3cb685d82e0daf802e77cff0fe493698313e1ee",
			username: username.toLowerCase(),
			password: password,
		}
		const querystring = require('querystring');
		return Axios.post(ServicesConfig.SESSION.GENERATE_TOKEN, querystring.stringify(params), {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		})
	},

	generateTokenPassword() {
		let params = {
			client_id: "5c33d14ecc761c4d05397c60",
			client_secret: "7bd640d2af2dc681aad57d86517299b87d3d1b8553bda2463fe598586d6dc8c2",
			scope: "email_checker register_user",
			grant_type: "client_credentials"
		}
		const querystring = require('querystring');
		return Axios.post(ServicesConfig.SESSION.GENERATE_TOKEN, querystring.stringify(params), {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		})
	},
	generateToken(authentication) {
		
		return Axios.post(ServicesConfig.SESSION.GENERATE_TOKEN, querystring.stringify(authentication), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
	},
	getInfoUserById(userId) {
		//console.log(authentication)

		let url = ServicesConfig.ASURAPI_SEGURIDAD.BASE_URL + '/security/token/user/' + params.userId + '/agency/24/app/SEG';
		return Axios.get(url)
			.then(res=> {
				let token = res.data;	
				console.log(token)			
				if(token){

					return Axios.get(AppConfig.siaerpBaseUrl + `Siaerp/GetUsuarioByUserId/${userId}`,{
						headers: {
							"TOKEN": token
						}
					})
					
				}
			})
		
	},
	getValidaSucursal() {
		return Axios.get(AppConfig.siaerpBaseUrl + `Siaerp/GetValidaSucursal`);
	},
	getInfoUserByEmail(email) {
		let params ={
			email : email
		}
		//console.log(authentication)
		return Axios.post(AppConfig.siaerpBaseUrl + `Siaerp/GetUsuarioByUserEmail/`,params)
	}

}